module.exports = __webpack_public_path__ + "media/newstyle/images/book-type-d947c81de082b8ed0ca468dc7ccf7150.svg";